import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseQuery';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: (args, api, extraOptions) => {
    const adjustedArgs = typeof args === 'string' ? `/auth${args}` : { ...args, url: `/auth${args.url}` };
    return baseQueryWithReauth(adjustedArgs, api, extraOptions);
  },
  tagTypes: ['User'],
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: '/login',
        method: 'POST',
        body: credentials,
      }),
      transformResponse: (response) => {
        // Store token in localStorage
        if (response.success && response.data?.tokens?.accessToken) {
          if (typeof window !== 'undefined') {
            localStorage.setItem('token', response.data.tokens.accessToken);
            localStorage.setItem('refreshToken', response.data.tokens.refreshToken);
          }
          return {
            token: response.data.tokens.accessToken,
            refreshToken: response.data.tokens.refreshToken,
            user: response.data.employee,
          };
        }
        return response;
      },
    }),
    logout: builder.mutation({
      query: () => ({
        url: '/logout',
        method: 'POST',
      }),
      transformResponse: () => {
        // Remove tokens from localStorage
        if (typeof window !== 'undefined') {
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
        }
        return { success: true };
      },
    }),
    getCurrentUser: builder.query({
      query: () => '/profile',
      providesTags: ['User'],
      transformResponse: (response) => {
        if (response.success) {
          return response.data.employee;
        }
        return null;
      },
    }),
    refreshToken: builder.mutation({
      query: (refreshToken) => ({
        url: '/refresh-token',
        method: 'POST',
        body: { refreshToken },
      }),
      transformResponse: (response) => {
        if (response.success && response.data?.tokens?.accessToken) {
          if (typeof window !== 'undefined') {
            localStorage.setItem('token', response.data.tokens.accessToken);
            localStorage.setItem('refreshToken', response.data.tokens.refreshToken);
          }
          return {
            token: response.data.tokens.accessToken,
            refreshToken: response.data.tokens.refreshToken,
          };
        }
        return response;
      },
    }),
    forgotPassword: builder.mutation({
      query: (data) => ({
        url: '/forgot-password',
        method: 'POST',
        body: data,
      }),
    }),
    resetPassword: builder.mutation({
      query: (data) => ({
        url: '/reset-password',
        method: 'POST',
        body: data,
      }),
    }),
    changePassword: builder.mutation({
      query: (data) => ({
        url: '/change-password',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useGetCurrentUserQuery,
  useRefreshTokenMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
} = authApi;
